import { render, staticRenderFns } from "./comCore.vue?vue&type=template&id=c47730ca&scoped=true&"
import script from "./comCore.vue?vue&type=script&lang=js&"
export * from "./comCore.vue?vue&type=script&lang=js&"
import style0 from "./comCore.vue?vue&type=style&index=0&id=c47730ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47730ca",
  null
  
)

export default component.exports